import cx from 'classnames';
import Button from 'common/components/elements/buttons/primary';
import Flag from 'common/components/elements/flags';
import IconLabel from 'common/components/elements/icon-label';
import Icon from 'common/components/elements/icons';
import Checkbox from 'common/components/elements/inputs/checkbox-label';
import Radio from 'common/components/elements/inputs/radio-label';
import Search from 'common/components/elements/inputs/search';
import { default as CircleLoader, default as Loader } from 'common/components/elements/loader/circle';
import TruncateText from 'common/components/elements/truncate-text';
import Avatar from 'common/components/modules/avatar';
import EmptyState from 'common/components/modules/empty-states';
import Modal from 'common/components/modules/modalV2';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import './style.scss';
import Intercom from 'common/utils/Intercom';

const FilterContent = ({
   data,
   desktopType = 'mobile',
   isMultiplSelect,
   isSearchable,
   activeSelectedValue,
   onScrollContent,
   filterNameKey,
   onCloseContent,
   isTopSeparate,
   onFilterChange = (...arg) => console.log(...arg),
   onClickShowResult = () => {},
   onSearchChange = () => {},
   searchPlaceholder = 'Search',
   isLoadinngData = false,
   primaryIcon,
   filterValueKey,
   style = {},
   onClickClear = () => {},
   isSort,
   children,
   animate,
   isDisabled,
   isAutoSave = true,
   onAutoFilter = () => {},
   onCloseDkContent,
   contentStyles = {},
   version,
   isEmpty,
   showNewRadioStyles,
   viewClassName = '',
   viewWidth,
   hasClearButton = true,
   contentMarginToLeftIcon,
   valueColor = 'text-major',
   contentCardsStyle = {},
   hasCloseButton = true,
   hasFilterButtonContent = true,
   checkboxLabelClassname = '',
   filterDescription = '',
   radioClassName,
   contentClassName = '',
   checkboxSize = '6',
   showCloseButton = false,
   showClearButton = true,
   disabledState = [],
   useIconLabel,
   showSelectAll,
   isSelectedAll,
   labelTooltipText = 'This view cannot be reordered',
   classNamesToRemove,
   isLoadingNextPageData,
   loaderClassName,
   contentId,
   useMemberAvatar,
   notShowTooltip = false,
   notTruncate = false,
   checkboxClassName,
   truncateTextSize,
   checkboxMargin,
   useCountryFlag = false,
   contentRef,
   showCloseButtonInsteadOfClear = false,
   scrollToCheckedElement,
   name,
   useEmoji,
   emojiKey,
   hiddenValues = [],
   overrideValueNameProps = {},
   loaderColor,
   scrollIntoViewOnOpenContent = false,
   hasTransactionFont,
   searchMargin = false,
   filterContentButtonClassName = '',
   newPaddingCheckbox = '',
   iconNewSize = '',
   searchiconClassName = '',
   searchIconSize = '',
   newHeightForPanel = '',
   paddingY = '',
   contentViewStyles = {},
   showLoaderInsideItem = false,
   itemLoaderClassName = '',
}) => {

   useEffect(() => {
      if('mobile' === desktopType || !scrollIntoViewOnOpenContent) return;

      const contentWrapper = document.getElementById('desktop-filter-content')
      if(!contentWrapper) return;


      contentWrapper.scrollIntoView({
         block: 'center',
         behavior: 'smooth',
      })

   }, [desktopType, scrollIntoViewOnOpenContent])

   const view =  <Content
      newPaddingCheckbox={ newPaddingCheckbox }
      data={ data }
      isMultiplSelect={ isMultiplSelect }
      isSearchable={ isSearchable }
      onScrollContent={ onScrollContent }
      filterNameKey={ filterNameKey }
      isTopSeparate={ isTopSeparate }
      activeValue={ activeSelectedValue }
      onFilterChange={ onFilterChange }
      onClickShowResult={ onClickShowResult }
      onSearchChange={ onSearchChange }
      searchPlaceholder={ searchPlaceholder }
      isLoadinngData={ isLoadinngData }
      primaryIcon={ primaryIcon }
      filterValueKey={ filterValueKey }
      onClickClear={ onClickClear }
      isSort={ isSort }
      children={ children }
      isDisabled={ isDisabled }
      isAutoSave={ isAutoSave }
      onAutoFilter={ onAutoFilter }
      onCloseDkContent={ onCloseDkContent }
      isMobile={ desktopType === 'mobile' }
      version={ version }
      isEmpty={ isEmpty }
      showNewRadioStyles={ showNewRadioStyles }
      viewClassName={ viewClassName }
      viewWidth={ viewWidth }
      hasClearButton={ hasClearButton }
      contentMarginToLeftIcon={ contentMarginToLeftIcon }
      valueColor={ valueColor }
      contentCardsStyle={ contentCardsStyle }
      hasCloseButton={ hasCloseButton }
      hasFilterButtonContent={ hasFilterButtonContent }
      checkboxLabelClassname={ checkboxLabelClassname }
      filterDescription={ filterDescription }
      radioClassName={ radioClassName }
      contentClassName={ contentClassName }
      checkboxSize={ checkboxSize }
      showCloseButton={ showCloseButton }
      showClearButton={ showClearButton }
      disabledState={ disabledState }
      useIconLabel={ useIconLabel }
      showSelectAll={ showSelectAll }
      isSelectedAll={ isSelectedAll }
      labelTooltipText={ labelTooltipText }
      classNamesToRemove={ classNamesToRemove }
      isLoadingNextPageData={ isLoadingNextPageData }
      loaderClassName={ loaderClassName }
      contentId={ contentId }
      useMemberAvatar={ useMemberAvatar }
      notShowTooltip={ notShowTooltip }
      notTruncate={ notTruncate }
      checkboxClassName={ checkboxClassName }
      truncateTextSize={ truncateTextSize }
      checkboxMargin={ checkboxMargin }
      useCountryFlag={ useCountryFlag }
      contentRef={ contentRef }
      showCloseButtonInsteadOfClear={ showCloseButtonInsteadOfClear }
      scrollToCheckedElement={ scrollToCheckedElement }
      name={ name }
      useEmoji={ useEmoji }
      emojiKey={ emojiKey }
      hiddenValues={ hiddenValues }
      overrideValueNameProps={ overrideValueNameProps }
      loaderColor={ loaderColor }
      hasTransactionFont={ hasTransactionFont }
      searchMargin={ searchMargin }
      filterContentButtonClassName={ filterContentButtonClassName }
      iconNewSize={ iconNewSize }
      searchiconClassName={ searchiconClassName }
      searchIconSize={ searchIconSize }
      newHeightForPanel={ newHeightForPanel }
      paddingY={ paddingY }
      contentViewStyles={ contentViewStyles }
      showLoaderInsideItem={ showLoaderInsideItem }
      itemLoaderClassName={ itemLoaderClassName }
   />
   if(desktopType === 'mobile'){
      return (
         <Modal
            onClose={ onCloseContent }
            roundedModal='lg'
            animate={ animate }
            otherClassName='filter-mobile-modal-content'
         >
            {view}
         </Modal>
      );

   } else {
      return (
         <div
            style={ {
               ...style,
               ...contentStyles,
               zIndex: '100 !important',
            } }
            className='absolute desktop-filter-content shadow dark:shadow-dark  dark:bg-panel-dark dark:text-major-dark dark:border-divider-dark border-divider !z-[1000]'
            id='desktop-filter-content'
         >
            {view}
         </div>
      )
   }

};

const Content = ({
   newPaddingCheckbox = '',
   data,
   isMultiplSelect,
   onScrollContent,
   filterNameKey,
   isTopSeparate,
   activeValue,
   onFilterChange,
   isSearchable,
   onClickShowResult,
   onSearchChange,
   searchPlaceholder,
   isLoadinngData,
   primaryIcon,
   filterValueKey,
   onClickClear,
   isSort,
   children,
   isDisabled,
   isAutoSave,
   onAutoFilter,
   onCloseDkContent,
   isMobile,
   version,
   isEmpty,
   showNewRadioStyles,
   viewClassName,
   viewWidth,
   hasClearButton,
   contentMarginToLeftIcon,
   valueColor,
   contentCardsStyle,
   hasCloseButton,
   hasFilterButtonContent,
   checkboxLabelClassname,
   filterDescription,
   radioClassName,
   contentClassName,
   checkboxSize,
   showCloseButton,
   showClearButton,
   disabledState,
   useIconLabel,
   showSelectAll,
   isSelectedAll,
   labelTooltipText,
   classNamesToRemove,
   isLoadingNextPageData,
   loaderClassName,
   contentId,
   useMemberAvatar,
   notShowTooltip,
   notTruncate,
   checkboxClassName,
   truncateTextSize,
   checkboxMargin,
   useCountryFlag,
   contentRef,
   showCloseButtonInsteadOfClear,
   scrollToCheckedElement,
   name,
   useEmoji,
   emojiKey,
   hiddenValues,
   overrideValueNameProps = {},
   loaderColor,
   hasTransactionFont,
   searchMargin,
   filterContentButtonClassName,
   iconNewSize,
   searchiconClassName = '',
   searchIconSize = '',
   newHeightForPanel = '',
   paddingY = '',
   contentViewStyles = {},
   showLoaderInsideItem = false,
   itemLoaderClassName = '',
}) => {
   const scrollToCheckedItem = () => {
      const element = document.getElementById('checked-item');
      const conteiner = document.getElementById('desktop-filter-content');
      if(element && conteiner) {
         const elementRect = element.getBoundingClientRect();
         const containerRect = conteiner.getBoundingClientRect();

         const offsetTop = elementRect.top - containerRect.top - 4;
         setTimeout(() => {
            conteiner.scrollTo({
               top: offsetTop,
               behavior: 'smooth',
            });
         }, 100);
      }
   };

   useEffect(() => {
      if(scrollToCheckedElement) {
         scrollToCheckedItem()
      }
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [scrollToCheckedElement])


   return (
      <div className='select-none'>
         {
            children ? (
               children
            ) : (
               <>
                  {
                     isSearchable && (
                        <>
                           {/* <div className='h-12 mx-1 mt-1 px-1 filter-search-content'> */}
                           <div className='mt-1 py-1 px-4 filter-search-content'>
                              <Search
                                 onChange={ (value) => {
                                    onSearchChange(value)
                                 } }
                                 placeholder={ searchPlaceholder }
                                 isDebounce
                                 className='!px-4 !py-2 gap-1'
                                 version='2'
                                 searchIconSize={ searchIconSize || 'xl' }
                                 clearIcon='xl'
                                 // isHideBorder
                              />
                           </div>
                           {/* <div className='w-full border-b dark:border-divider-dark border-divider filter-search-divider' /> */}
                        </>
                     )
                  }
                  <div
                     onScroll={ onScrollContent ?  (e) => onScrollContent(e) : null }
                     id={ contentId }
                     className={ cx({
                        'flex flex-col overflow-y-auto resposnive-filter py-1': true,
                        'resposnive-filter-content-simpl': isLoadinngData,
                        'resposnive-filter-content': !classNamesToRemove?.includes('resposnive-filter-content') && isSearchable,
                        'py-1': 'v2' === version,
                        'p-0': 'v1' === version,
                        'ams-custom-scrool': !isMobile,
                        '!px-0 !py-1': !!contentCardsStyle && contentCardsStyle?.forContent,
                        'resposnive-filter-searchable': isSearchable,
                        [`${ contentClassName }`]: !!contentClassName,
                     }) }
                     ref={ contentRef }
                     style={ { ...contentViewStyles } }
                  >
                     {
                        !isLoadinngData && data?.length === 0 && (
                           <div className='p-2 flex-1'>
                              <EmptyState type={ 'search' } />
                           </div>
                        )
                     }
                     {
                        isLoadinngData && (
                           <div className='h-full w-full flex items-center justify-center min-h-24'>
                              <Loader color={ loaderColor || 'primary' } />
                           </div>
                        )
                     }
                     {
                        filterDescription !== '' && <div className='py-[10px] px-2'>
                           <span className='font-normal text-sm text-secondary dark:text-secondary-dark '>{filterDescription}</span>
                        </div>
                     }
                     {
                        isMultiplSelect && showSelectAll &&
                           <Checkbox
                              name={ `select_all_filter_item_${ contentId }` }
                              onChange={ () => {
                                 onFilterChange('select_all', 'Select all')
                              } }
                              checked={ isSelectedAll }
                              position='right'
                              className={ cx({
                                 'border-b dark:border-divider-dark border-divider': isTopSeparate,
                                 'hover:bg-hover dark:hover:bg-hover-dark text-sm': true,
                                 'checkbox_v2': 'v2' === version,
                              }) }
                              labelClassName={ checkboxLabelClassname }
                              padding={ !!contentCardsStyle && contentCardsStyle?.forContent ? '[10px]' : 'v2' === version ? `py-2 ${ newPaddingCheckbox?.length ? `${ newPaddingCheckbox } py-2` : 'py-2 px-[14px]' }` : '3' } checkboxSize={ checkboxSize }
                           >
                              <>
                                 <TruncateText
                                    textClass={ cx({
                                       // 'pr-2': useIconLabel,
                                    }) }
                                    className={ cx({
                                       'w-full flex justify-end items-center text-major dark:text-major-dark': true,
                                    }) }
                                    text={ 'Select all' }
                                    textSize='14px'
                                    fontWeight='400'
                                    width='calc(100% - 24px)'
                                 />
                              </>
                           </Checkbox>
                     }
                     {
                        !isLoadinngData && !!data?.length && data.map((value, index) => {
                           let isSelected = false;
                           let activeData = activeValue.value
                           if(isMultiplSelect && Array.isArray(activeData)) {
                              isSelected = activeData.includes(value[filterValueKey])
                           }
                           let icon = primaryIcon ? primaryIcon : value.icon

                           // const color = value.color

                           const background = value.background

                           let isDisabledOption = disabledState.includes(value[filterValueKey])

                           if(hiddenValues && Array.isArray(hiddenValues) && hiddenValues.includes(value[filterValueKey])) {
                              return null
                           }

                           const view = (
                              <div
                                 className={ cx({
                                    [`flex w-4/5 ${ viewClassName }`]: true,
                                    [`gap-2`]: useMemberAvatar,
                                    'notranslate': 'Cast members' === name || 'Models' === name,
                                    'items-center': !!value?.email && useMemberAvatar,
                                 }) }
                              >
                                 {
                                    useIconLabel &&
                                    <IconLabel
                                       className='w-6 h-6 min-w-[24px] min-h-6'
                                       name={ value?.iconProps?.iconName }
                                       color={ value?.iconProps?.color }
                                       size='base'
                                    />
                                 }
                                 {
                                    useMemberAvatar &&
                                       <Avatar
                                          avatarSrc={ value?.avatar }
                                          size='24px'
                                          username={ value?.name }
                                          className={ `min-h-[24px] min-w-[24px]` }
                                          isDeleted={ !!value?.deleted_at }
                                          deletedIconSize=' !text-sm'
                                       />
                                 }
                                 {
                                    icon && (
                                       <div
                                          style={ { minWidth: '24px' } }
                                          className={ `h-6 w-6 flex items-center justify-center rounded-[100px] p-[7px_5px] ${ background }` }>
                                          <Icon name={ icon } size='xl' color={ isDisabledOption ? 'disabled' : value?.iconColor || 'secondary' } />
                                       </div>
                                    )
                                 }
                                 {
                                    useCountryFlag &&
                                    <Flag
                                       country={ value[filterValueKey] }
                                       className='!px-0 flex justify-center items-center mr-3'
                                       width='20px'
                                       height='20px'
                                    />
                                 }
                                 {
                                    value && value.status && !!Object.keys(value.status).length ? (
                                       <p
                                          className={ cx(
                                             'flex items-center justify-center w-18 h-6 text-major-dark rounded-full text-xs mr-5 item-status-min-width',
                                             value.status.color
                                          ) }
                                       >
                                          {value.status.name}
                                       </p>
                                    ) : ''
                                 }
                                 {
                                    useEmoji && value[emojiKey] && (
                                       <span
                                          className='mr-1'
                                       >
                                          {value[emojiKey]}
                                       </span>
                                    )
                                 }
                                 <>
                                    <div className={ cx({
                                       'w-full': true,
                                       'flex flex-col gap-1': !!value?.email,
                                       'flex gap-1 items-center': !!value?.articleId,
                                    }) }>
                                       <TruncateText
                                          textClass={ cx({
                                             'leading-tight dark:text-major-dark': isTopSeparate && index !== data.length - 1,
                                             [`${ valueColor } dark:text-major-dark`]: 'v2' === version,
                                             '!font-medium text-major dark:text-major-dark': 'v1' === version,
                                             [`ml-${ contentMarginToLeftIcon }`]: icon,
                                             '!font-normal !text-base': !!contentCardsStyle && contentCardsStyle?.forContent,
                                             '!text-disabled': isDisabledOption,
                                             'pl-2': useIconLabel,
                                             'text-base': true,
                                             '!w-fit': value?.articleId,
                                          }) }
                                          className={ cx({
                                             'w-full': true,
                                             'items-center': isTopSeparate && index !== data.length - 1,
                                             '!w-fit': value?.articleId,
                                          }) }
                                          text={ value[filterNameKey] }
                                          textSize={ truncateTextSize }
                                          fontWeight={ 'v1' === version ? '500' : '400' }
                                          width={ notTruncate ? 'full' : 'calc(100% - 24px)' }
                                          notShowTooltip={ notShowTooltip }
                                          styles={ {
                                             fontFamily: value?.font || '',
                                          } }
                                          innerTextAsHTML={ value?.innerTextAsHTML }
                                          { ...overrideValueNameProps }
                                       />
                                       {
                                          !!value?.email && (
                                             <TruncateText
                                                text={ value.email }
                                                textSize='13px'
                                                textClass='text-[13px] text-secondary leading-4'
                                             />
                                          )
                                       }
                                       {
                                          Boolean(value?.articleId) && (
                                             <Icon
                                                role='presentation'
                                                onClick={ (e) => {
                                                   e.stopPropagation();
                                                   e.preventDefault();
                                                   Intercom.showArticle(value.articleId)
                                                } }
                                                name='help-outline'
                                                size='xl'
                                                color='placeholder'
                                                data-tooltip-content={ value?.articleTooltipText || '' }
                                                data-tooltip-id='ams-bottom-tooltip'
                                             />
                                          )
                                       }
                                    </div>

                                    {
                                       value.count && <span className='text-placeholder dark:text-placeholder-dark'>&nbsp; • {value.count}</span>
                                    }
                                    {
                                       value?.price && <span className='text-secondary dark:text-secondary-dark  text-xs'>
                                          {value?.price}
                                       </span>
                                    }
                                 </>
                              </div>
                           )

                           if(showLoaderInsideItem) {
                              return  <div
                                 className={ cx({
                                    'flex py-[10px] px-4': true,
                                    'hover:bg-hover dark:hover:bg-hover-dark': true,
                                    'hover:cursor-pointer': !value?.isLoadingItem,
                                 }) }
                                 role='presentation'
                                 onClick={ () => {
                                    onFilterChange(value[filterValueKey], value[filterNameKey])
                                 } }
                              >
                                 {
                                    view
                                 }
                                 {
                                    value?.isLoadingItem &&
                                    <div className={ `flex items-center justify-center px- ${ itemLoaderClassName }` }>
                                       <CircleLoader color='secondary' size={ '6' } />
                                    </div>
                                 }
                              </div>

                           }
                           if(!!isMultiplSelect) {
                              return (
                                 <div
                                    key={ index.toString() }
                                 >
                                    <Checkbox
                                       name={ `${ value[filterValueKey] }_filter` }
                                       onChange={ () => {
                                          if(isAutoSave && !isMobile) {
                                             onAutoFilter(value[filterValueKey], value[filterNameKey])
                                          } else {
                                             onFilterChange(value[filterValueKey], value[filterNameKey])
                                          }
                                       } }
                                       checked={ isSelected }
                                       position='right'
                                       className={ cx({
                                          'border-b dark:border-divider-dark border-divider': isTopSeparate && index !== data.length - 1,
                                          'hover:bg-hover dark:hover:bg-hover-dark': true,
                                          'checkbox_v2': 'v2' === version,
                                          [`${ checkboxClassName }`]: Boolean(checkboxClassName),
                                          'intercom-my-favorites-member': value[filterValueKey] === 'favorite',
                                          'items-center': !!value?.email && useMemberAvatar,
                                       }) }
                                       labelClassName={ `${ checkboxLabelClassname } !h-fit` }
                                       padding={ !!contentCardsStyle && contentCardsStyle?.forContent ? '[10px]' : 'v2' === version ? `py-2 ${ newPaddingCheckbox?.length ? `${ newPaddingCheckbox } !py-2` : 'py-2 px-[14px]' }` : '3' }
                                       checkboxSize={ checkboxSize }
                                       disabled={ isDisabledOption }
                                       margin={ checkboxMargin }
                                       isSelectedState
                                       labelTooltipText={ isDisabledOption ? labelTooltipText : '' }
                                    >
                                       {view}
                                    </Checkbox>
                                 </div>
                              )
                           } else {
                              return (
                                 <div
                                    id={ activeData && (activeData === value[filterValueKey] || activeValue[filterValueKey] === value[filterValueKey])  ? 'checked-item' : '' }
                                    key={ value.id ? value.id : index.toString() }
                                 >
                                    <Radio
                                       id={ `${ value[filterValueKey] }_filter` }
                                       onChange={ () => onFilterChange(value[filterValueKey], value[filterNameKey]) }
                                       checked={ activeData && (activeData === value[filterValueKey] || activeValue[filterValueKey] === value[filterValueKey]) }
                                       className={ cx({
                                          'border-b dark:border-divider-dark border-divider': isTopSeparate && index !== data.length - 1,
                                          'hover:bg-hover dark:hover:bg-hover-dark': !isDisabledOption,
                                          [`${ radioClassName }`]: !!radioClassName,
                                       }) }
                                       paddingY={ !!contentCardsStyle && contentCardsStyle?.forContent ? '[10px]' : 'v2' === version ? `${ newPaddingCheckbox?.length ? paddingY || newPaddingCheckbox : '2' }  px-[14px]` : '3' }
                                       disabled={ isDisabledOption }
                                       isSelectedState
                                       labelTooltipText={ isDisabledOption ? labelTooltipText : '' }
                                    >
                                       {view}
                                    </Radio>
                                 </div>
                              )
                           }
                        })
                     }
                     {
                        isLoadingNextPageData &&
                        <div className={ `flex items-center justify-center ${ loaderClassName }` }>
                           <CircleLoader color='primary' />
                        </div>
                     }
                  </div>
               </>
            )
         }
         {
            !isMultiplSelect && isAutoSave && !!activeValue.value && (activeValue.value.length > 0 || activeValue.name?.length > 0) && hasClearButton && (
               <div
                  className={ cx(
                     'flex bg-panel dark:bg-panel-dark rounded-b-lg items-center justify-between filter-button-content',
                     isMultiplSelect && `p-button-content h-${ newHeightForPanel || '14' }`
                  ) }
               >
                  <div className='h-9 clear-button'>
                     <Button
                        text='Clear'
                        textColor='secondary dark:text-secondary-dark '
                        backgroundColor='transparent'
                        textSize='base'
                        onClick={ onClickClear }
                        classNames='h-full flex px-2 items-center'
                        padding='none'
                        iconName='cancel'
                        fontIconColor='secondary'
                        darkIconColor='secondary-dark'
                        fontIconSize={ hasTransactionFont ? 'extraLarge' : 'large' }
                        iconPosition='left'
                     />
                  </div>
               </div>
            )
         }
         {
            !isEmpty && (isMobile || (!isSort && isMultiplSelect)) && hasFilterButtonContent && (
               <div
                  className={ cx(
                     'flex bg-panel dark:bg-panel-dark rounded-b-lg items-center justify-between filter-button-content',
                     isMultiplSelect && `p-button-content h-${ newHeightForPanel || '14' }`
                  ) }
               >
                  {
                     showClearButton && (
                        isMobile && hasClearButton ?
                           (
                              <div className='h-9 clear-button'>
                                 <Button
                                    text='Clear'
                                    textColor='secondary dark:text-secondary-dark '
                                    backgroundColor='transparent'
                                    textSize='base'
                                    onClick={ onClickClear }
                                    classNames='h-full flex px-2 items-center dark:text-major-dark'
                                    padding='none'
                                    iconName='cancel'
                                    fontIconColor='secondary'
                                    darkIconColor='secondary-dark'
                                    fontIconSize={ hasTransactionFont ? 'extraLarge' : 'large' }
                                    iconPosition='left'
                                 />
                              </div>
                           )
                           : (!!activeValue.value && (activeValue.value.length > 0 || activeValue?.value?.startDate || activeValue?.value?.endDate)) &&
                           (
                              <div className='h-9 clear-button'>
                                 <Button
                                    text={ showCloseButton ? 'Close' : 'Clear' }
                                    textColor='secondary dark:text-secondary-dark '
                                    backgroundColor='transparent'
                                    textSize='small'
                                    onClick={ onClickClear }
                                    classNames='h-full flex px-2 items-center'
                                    padding='none'
                                    iconName={ showCloseButton ? '' : 'cancel' }
                                    fontIconColor='secondary'
                                    darkIconColor='secondary-dark'
                                    fontIconSize={ hasTransactionFont ? 'extraLarge' : 'large' }
                                    iconPosition='left'
                                    textMarginX='0 ml-2'
                                 />
                              </div>
                           )
                     )
                  }
                  {
                     isAutoSave && !isMobile && hasCloseButton && (
                        <div className='h-9 clear-button ml-auto'>
                           <Button
                              text='Close'
                              textColor='secondary dark:text-secondary-dark '
                              backgroundColor='transparent'
                              textSize='small'
                              onClick={ () => onCloseDkContent() }
                              classNames='h-full flex px-2 items-center dark:text-major-dark'
                              padding='none'
                              fontIconSize={ hasTransactionFont ? 'extraLarge' : 'large' }
                           />
                        </div>
                     )
                  }

                  {
                     isMobile && isAutoSave && (
                        <div className='h-9 ml-auto'>
                           <Button
                              text='Apply'
                              primaryColor
                              textSize='base'
                              onClick={ onClickShowResult }
                              padding='none'
                              disabled={ isDisabled }
                              borderRadius='large'
                              classNames='px-3 h-full'
                           />
                        </div>
                     )
                  }
                  {
                     isMultiplSelect && !isAutoSave && (
                        <div className='h-9 filter-show-result ml-auto'>
                           <Button
                              text={ isMobile ? 'Apply' : 'Show results' }
                              primaryColor
                              textSize='small'
                              onClick={ onClickShowResult }
                              padding='none'
                              disabled={ isDisabled }
                              borderRadius='large'
                              classNames={ `px-3 h-full ${ filterContentButtonClassName }` }
                              textMarginX='0'
                           />
                        </div>
                     )
                  }
               </div>
            )
         }
      </div>
   )
}


FilterContent.propTypes = {
   data: PropTypes.array.isRequired,
   desktopType: PropTypes.string,
   filterNameKey: PropTypes.string,
   isTopSeparate: PropTypes.bool,
   onFilterChange: PropTypes.func,
   onClickShowResult: PropTypes.func,
   onSearchChange: PropTypes.func,
   searchPlaceholder: PropTypes.string,
   isLoadinngData: PropTypes.bool,
   primaryIcon: PropTypes.string,
   style: PropTypes.object,
   isSort: PropTypes.bool,
   onClickClear: PropTypes.func,
   isDisabled: PropTypes.bool,
   children: PropTypes.any,
   isAutoSave: PropTypes.bool,
   onAutoFilter: PropTypes.func,
   onCloseDkContent: PropTypes.func,
   contentStyles: PropTypes.object,
   isMultiplSelect: PropTypes.bool,
   isSearchable: PropTypes.bool,
   activeSelectedValue: PropTypes.any,
   onScrollContent: PropTypes.func,
   onCloseContent: PropTypes.func,
   animate: PropTypes.any,
   filterValueKey: PropTypes.any,
   version: PropTypes.string,
   isEmpty: PropTypes.bool,
   showNewRadioStyles: PropTypes.bool,
   viewClassName: PropTypes.string,
   viewWidth: PropTypes.string,
   contentMarginToLeftIcon: PropTypes.number,
   hasClearButton: PropTypes.bool,
   valueColor: PropTypes.string,
   contentCardsStyle: PropTypes.object,
   hasCloseButton: PropTypes.bool,
   hasFilterButtonContent: PropTypes.bool,
   checkboxLabelClassname: PropTypes.string,
   filterDescription: PropTypes.string,
   radioClassName: PropTypes.string,
   contentClassName: PropTypes.string,
   checkboxSize: PropTypes.string,
   showCloseButton: PropTypes.bool,
   showClearButton: PropTypes.bool,
   disabledState: PropTypes.array,
   useIconLabel: PropTypes.bool,
   showSelectAll: PropTypes.bool,
   isSelectedAll: PropTypes.bool,
   labelTooltipText: PropTypes.string,
   classNamesToRemove: PropTypes.array,
   isLoadingNextPageData: PropTypes.bool,
   contentId: PropTypes.string,
   useMemberAvatar: PropTypes.bool,
   loaderClassName: PropTypes.string,
   notShowTooltip: PropTypes.bool,
   notTruncate: PropTypes.bool,
   checkboxClassName: PropTypes.string,
   truncateTextSize: PropTypes.string,
   checkboxMargin: PropTypes.string,
   useCountryFlag: PropTypes.bool,
   contentRef: PropTypes.any,
   showCloseButtonInsteadOfClear: PropTypes.bool,
   scrollToCheckedElement: PropTypes.bool,
   name: PropTypes.string,
   useEmoji: PropTypes.string,
   emojiKey: PropTypes.string,
   hiddenValues: PropTypes.array,
   overrideValueNameProps: PropTypes.object,
   loaderColor: PropTypes.string,
   scrollIntoViewOnOpenContent: PropTypes.bool,
   hasTransactionFont: PropTypes.bool,
   searchMargin: PropTypes.bool,
   filterContentButtonClassName: PropTypes.string,
   newPaddingCheckbox: PropTypes.string,
   iconNewSize: PropTypes.string,
   searchiconClassName: PropTypes.string,
   searchIconSize: PropTypes.string,
   newHeightForPanel: PropTypes.string,
   paddingY: PropTypes.string,
   contentViewStyles: PropTypes.object,
   showLoaderInsideItem: PropTypes.bool,
   itemLoaderClassName: PropTypes.string,
};
Content.propTypes = {
   data: PropTypes.array.isRequired,
   isMultiplSelect: PropTypes.bool,
   onScrollContent: PropTypes.func,
   filterNameKey: PropTypes.string,
   isTopSeparate: PropTypes.bool,
   isSearchable: PropTypes.bool,
   activeValue: PropTypes.any,
   onFilterChange: PropTypes.func,
   onClickShowResult: PropTypes.func,
   onSearchChange: PropTypes.func,
   searchPlaceholder: PropTypes.string,
   isLoadinngData: PropTypes.bool,
   primaryIcon: PropTypes.string,
   filterValueKey: PropTypes.string,
   isSort: PropTypes.bool,
   onClickClear: PropTypes.func,
   isDisabled: PropTypes.bool,
   children: PropTypes.any,
   isAutoSave: PropTypes.bool,
   onAutoFilter: PropTypes.func,
   onCloseDkContent: PropTypes.func,
   isMobile: PropTypes.bool,
   version: PropTypes.string,
   isEmpty: PropTypes.bool,
   showNewRadioStyles: PropTypes.bool,
   viewClassName: PropTypes.string,
   viewWidth: PropTypes.string,
   contentMarginToLeftIcon: PropTypes.number,
   hasClearButton: PropTypes.bool,
   valueColor: PropTypes.string,
   contentCardsStyle: PropTypes.object,
   hasCloseButton: PropTypes.bool,
   hasFilterButtonContent: PropTypes.bool,
   checkboxLabelClassname: PropTypes.string,
   filterDescription: PropTypes.string,
   radioClassName: PropTypes.string,
   contentClassName: PropTypes.string,
   checkboxSize: PropTypes.string,
   showCloseButton: PropTypes.bool,
   showClearButton: PropTypes.bool,
   disabledState: PropTypes.array,
   useIconLabel: PropTypes.bool,
   showSelectAll: PropTypes.bool,
   isSelectedAll: PropTypes.bool,
   labelTooltipText: PropTypes.string,
   classNamesToRemove: PropTypes.array,
   isLoadingNextPageData: PropTypes.bool,
   contentId: PropTypes.string,
   useMemberAvatar: PropTypes.bool,
   loaderClassName: PropTypes.string,
   notShowTooltip: PropTypes.bool,
   notTruncate: PropTypes.bool,
   checkboxClassName: PropTypes.string,
   truncateTextSize: PropTypes.string,
   checkboxMargin: PropTypes.string,
   useCountryFlag: PropTypes.bool,
   contentRef: PropTypes.any,
   showCloseButtonInsteadOfClear: PropTypes.bool,
   scrollToCheckedElement: PropTypes.bool,
   name: PropTypes.string,
   useEmoji: PropTypes.string,
   emojiKey: PropTypes.string,
   hiddenValues: PropTypes.array,
   overrideValueNameProps: PropTypes.object,
   loaderColor: PropTypes.string,
   hasTransactionFont: PropTypes.bool,
   searchMargin: PropTypes.bool,
   filterContentButtonClassName: PropTypes.string,
   newPaddingCheckbox: PropTypes.string,
   iconNewSize: PropTypes.string,
   searchiconClassName: PropTypes.string,
   searchIconSize: PropTypes.string,
   newHeightForPanel: PropTypes.string,
   paddingY: PropTypes.string,
   contentViewStyles: PropTypes.object,
   showLoaderInsideItem: PropTypes.bool,
   itemLoaderClassName: PropTypes.string,
};

export default FilterContent;
